module.exports = __webpack_public_path__ + "1.4.15-unryo/img/apache.668a77b3.svg";